import { useQuery } from '@tanstack/react-query';
import { getTeamMentionsSearch } from '@/api/creatorApi';
import { getTokenFromStorage } from '@/utils/auth';

const PAGE_SIZE = 5;

export interface DashboardTeamMentionRow {
  mention_id: string;
  creator_id: string;
  creatorlist_id: string;
  content_id: string;
  keyword: string;
  date_created: string;
  handle: string | null;
  platform: string | null;
  /** Content preview image URL (CDN or platform). */
  preview_url: string | null;
  /** Creator profile image URL. */
  mugshot_url: string | null;
}

export function useDashboardRecentTeamMentions(enabled: boolean) {
  return useQuery({
    queryKey: ['dashboard-recent-team-mentions', PAGE_SIZE],
    enabled: enabled && Boolean(getTokenFromStorage()),
    queryFn: async (): Promise<DashboardTeamMentionRow[]> => {
      const token = getTokenFromStorage();
      if (!token) {
        throw new Error('No authentication token available');
      }
      const res = await getTeamMentionsSearch(token, PAGE_SIZE, 0);
      const rows: DashboardTeamMentionRow[] = [];
      for (const m of res.mentions ?? []) {
        const creatorlistId = m.creatorlist_id?.trim() ?? '';
        if (!creatorlistId) continue;
        const handle = m.creator?.handle?.trim() || null;
        const platform = m.content?.platform?.trim() || null;
        rows.push({
          mention_id: m.mention_id,
          creator_id: m.creator?.creator_id ?? '',
          creatorlist_id: creatorlistId,
          content_id: m.content?.content_id ?? '',
          keyword: m.keyword ?? '',
          date_created: typeof m.date_created === 'string' ? m.date_created : String(m.date_created),
          handle,
          platform,
          preview_url: m.content?.preview_url?.trim() || null,
          mugshot_url: m.creator?.mugshot_url?.trim() || null,
        });
      }
      return rows;
    },
    staleTime: 60 * 1000,
    retry: 1,
  });
}
